import { Validator } from '@vista-digital/validator';
export const quickNavigatorEventsValidator = Validator.object({
    onActionButtonClicked: Validator.optional(Validator.fn()),
    onResetButtonClicked: Validator.optional(Validator.fn())
});
//# sourceMappingURL=events.js.map